import * as THREE from 'three';

export const SIGNAL = {
  reward: '#ffcc33',
  boost: '#22d3ee',
  hazard: '#e8503a',
  objective: '#7dffb3',
  danger: '#ff5a4d',
};

export const materialLibrary = {
  bodyPrimary: new THREE.MeshPhysicalMaterial({
    color: '#f24d3d', metalness: 0.0, roughness: 0.34,
    clearcoat: 0.8, clearcoatRoughness: 0.2, envMapIntensity: 1.0,
  }),
  bodySecondary: new THREE.MeshPhysicalMaterial({
    color: '#2b3550', metalness: 0.0, roughness: 0.4,
    clearcoat: 0.7, clearcoatRoughness: 0.22, envMapIntensity: 0.9,
  }),
  trim: new THREE.MeshStandardMaterial({
    color: '#20262e', metalness: 0.85, roughness: 0.3, envMapIntensity: 1.1,
  }),
  chrome: new THREE.MeshStandardMaterial({
    color: '#c8ccd4', metalness: 1.0, roughness: 0.18, envMapIntensity: 1.25,
  }),
  glass: new THREE.MeshPhysicalMaterial({
    color: '#9fd8ff', metalness: 0.0, roughness: 0.08,
    transparent: true, opacity: 0.42, clearcoat: 1.0, clearcoatRoughness: 0.05,
    envMapIntensity: 1.5, depthWrite: false,
  }),
  hazard: new THREE.MeshStandardMaterial({
    color: '#e8503a', metalness: 0.1, roughness: 0.5, envMapIntensity: 0.6,
  }),
  reward: new THREE.MeshStandardMaterial({
    color: '#201a08', emissive: '#ffcc33', emissiveIntensity: 2.2,
    metalness: 0.2, roughness: 0.35,
  }),
  boost: new THREE.MeshStandardMaterial({
    color: '#08222a', emissive: '#22d3ee', emissiveIntensity: 2.4,
    metalness: 0.2, roughness: 0.3,
  }),
  objective: new THREE.MeshStandardMaterial({
    color: '#0a2416', emissive: '#7dffb3', emissiveIntensity: 2.6,
    metalness: 0.1, roughness: 0.35,
  }),
  emissiveSignal: new THREE.MeshStandardMaterial({
    color: '#101010', emissive: '#ffe9b0', emissiveIntensity: 2.0,
    metalness: 0.0, roughness: 0.4,
  }),
  groundContact: new THREE.MeshStandardMaterial({
    color: '#16323a', metalness: 0.05, roughness: 0.9, envMapIntensity: 0.4,
  }),
  wood: new THREE.MeshStandardMaterial({
    color: '#8a5a33', roughness: 0.85, metalness: 0.0,
  }),
  rock: new THREE.MeshStandardMaterial({
    color: '#5d6672', roughness: 0.95, metalness: 0.02,
  }),
  sand: new THREE.MeshStandardMaterial({
    color: '#e6d3a3', roughness: 0.95, metalness: 0.0,
  }),
  palmTrunk: new THREE.MeshStandardMaterial({
    color: '#7c5a3e', roughness: 0.9,
  }),
  palmLeaf: new THREE.MeshStandardMaterial({
    color: '#2e8b4f', roughness: 0.8, side: THREE.DoubleSide,
  }),
  cloudWhite: new THREE.MeshStandardMaterial({
    color: '#ffffff', roughness: 1.0, metalness: 0.0, emissive: '#fff8ee', emissiveIntensity: 0.35,
  }),
  hullRed: new THREE.MeshStandardMaterial({
    color: '#c2362f', roughness: 0.55, metalness: 0.05,
  }),
  whitePaint: new THREE.MeshStandardMaterial({
    color: '#f4f6f8', roughness: 0.5, metalness: 0.05,
  }),
};

export function disposeMaterialLibrary(): void {
  for (const material of Object.values(materialLibrary)) material.dispose();
}
